// extracted by mini-css-extract-plugin
export default {"provincepath":"PriceMapRegion_provincepath__0wAUD","path":"PriceMapRegion_path__BrggY"};